<script lang="ts">
    import GridRowView from './GridRow.View.svelte';

    import type { GridRowContent } from '$lib/types/Components/GridRow/GridRowContent';
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Field } from '$lib/types/Field';
    import type { Language } from '$lib/types/Language';
    import type { ResultMapping } from '$lib/types/ResultMapping';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let content: GridRowContent;
    export let childComponents: Component[] = [];
    export let resultMapping: ResultMapping = {
        _id: '',
        companyId: '',
        campaignId: '',
    };
    export let theme: Theme;
    export let nextPage = '';
    export let currentPage = '';
    export let campaignId = '';
    export let campaignVersionId = '';
    export let companyId = '';
    export let cookiesEnabled = false;
    export let fields: Field[] = [];
    export let firstResultPage = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'en';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
</script>

<GridRowView
    box={content.box}
    {id}
    {childComponents}
    {resultMapping}
    {theme}
    {nextPage}
    {currentPage}
    {campaignId}
    {campaignVersionId}
    {companyId}
    {cookiesEnabled}
    {fields}
    {firstResultPage}
    {trackingProperties}
    {language}
    {transitionDelay}
    {transitionEffect}
/>
